<template>
<div v-show="isUpdatePrimaryManagerModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal Header -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="modal-title">
                        &nbsp;
                    </div>
                </div>
                <div class="close-icon">
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row">
                    <div class="col-12" style="font-size: 15px; margin-bottom: 15px; margin-top: -50px;" v-if="admins.length > 0">
                        You are inactivating the primary admin. Please select a manager below to assign as the primary admin or add a new manager.
                    </div>
                    <div class="col-12" style="font-size: 15px; margin-bottom: 15px; margin-top: -50px;" v-else-if="loading == false && admins.length == 0">
                        No Managers found to make Primary. You have to add a new one to inactivate this manager.
                        <div class="text-center" style="margin-top: 5px;">
                            <a href="#" class="btn ma-blue-btn btn-md text-white font-weight-bold rounded-pill px-3" @click.prevent="openAddMentorModal('mentor')">Add Manager</a>
                        </div>
                    </div>
                    <div class="col-12">
                        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                        <div v-if="admins.length > 0" class="row_lists">
                            <label class="form-label">Select a manager below to assign as primary:</label>
                            <div class="data_item" v-for="(item, aindex) in admins" :key="aindex">
                                  <div class="admin_item_1">
                                      <input 
                                          type="radio" 
                                          name="assign_padmin"
                                          id="assign_padmin"
                                          :value="item.uid"
                                          v-model="primary_admin_selected"
                                          v-validate="'required'" style="margin-top: 4px;">
                                  </div>
                                  <div class="admin_item_2">{{ item.admin_fname  + ' ' + item.admin_lname }}</div>
                                  <div class="clearfix"></div>
                            </div>
                            <div v-if="verrors.firstByRule('assign_padmin', 'required')" :class="'margin-bottom-5 validate-warning-msg ' + vmessage">Primary admin is required</div>
                        </div>
                    </div>
                </div>
                <br/>
                  <div class="row m-4" v-if="this.admins.length > 0">
                    <div class="col-6">
                        <button type="button" class="float-left btn btn-sm closeBtn" @click="closeModal">Cancel</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="float-right btn btn-sm ma-blue-btn" :disabled="disable_submit_btn" @click="updatePrimaryAdmin">Inactivate</button>
                    </div>
                  </div>
                  <div v-else class="row justify-content-center">
                    <button type="button" class="float-left btn btn-sm closeBtn" @click="closeModal">Cancel</button>
                  </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isUpdatePrimaryManagerModalVisible',
    'readOnly',
    ],
  data() {
    return {
        loading: false,
        userInfo: {},
        admins: [],
        accountId: '',
        primary_admin_selected: '',
        vmessage: '',
        name: '',
        disable_submit_btn: false,
    }
  },
  methods: {
    openAddMentorModal() {
        this.closeModal();
        this.$parent.openAddMentorModal('manager');
    },
    closeModal() {
        this.primary_admin_selected = '';
        this.$emit('close');
    },
    setUserInfo(user) {
        this.vmessage = "hide_vmessage";
        this.userInfo = user;
    },
    capitalizeFirstLetter(string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
          return "";
        }
    },
    getAllAdmins(account_id) {
        this.accountId = account_id;
        this.admins = [];
        this.loading = true;
        axios('/enterprise-admin/get-account-admins/' + this.accountId,
        {
            method: 'GET'
        })
        .then(resp => {
            this.loading = false;
            for (var m = 0; m < resp.data.length; m++) {
              if (this.userInfo.email != resp.data[m].admin_email) {
                var userObj = { 
                  "admin_fname": resp.data[m].admin_fname,
                  "admin_lname": resp.data[m].admin_lname,
                  "admin_email": resp.data[m].admin_email,
                  "uid": resp.data[m].uid
                }
                this.admins.push(userObj);
              }
            }
        })
        .catch(() => {
        });
    },
    updatePrimaryAdmin() {
        this.vmessage = "show_vmessage";
        this.$validator.validateAll().then((result) => {
            if (this.verrors.items.length === 0) {
                this.loading = true;
                axios('/enterprise-admin/update-account-primary-admin/' + this.accountId,
                {
                    method: 'PATCH',
                    data: {
                        new_primary_admin: this.primary_admin_selected,
                        remove_old_primary_admin: this.userInfo.id,
                    }
                })
                .then(resp => {
                    this.loading = false;
                    this.name = this.userInfo.first_name + ' ' + this.userInfo.last_name;      

                    this.disable_submit_btn = true;
                    axios('/desktop/v2/inactivate-user',
                    {
                      method: 'POST',
                      data: {
                        user_id: this.userInfo.id,
                        account_id: this.$store.state.user_accountid,
                        action: 'inactivate',
                      },
                    })
                    .then(() => {       
                      this.disable_submit_btn = false;   
                      let message = 'Inactivated ' + this.userInfo.first_name + ' ' + this.userInfo.last_name + ' successfully.';
                      this.$emit('close');
                      this.flash({ message: message, variant: 'success' });
                      window.location.reload(); 
                    })
                    .catch((error) => {
                      this.disable_submit_btn = false;   
                    });
                    //this.$parent.reloadOverviewTab();
                    this.closeModal();
                })
                .catch(() => {
                });
            }
        });
    },
    getNoRecordText() {
        if (this.loading) {
            return '';
        } else {
            if (this.admins.length == 0 && this.accountId) {
                return 'No Managers found to make Primary. You have to add a new one to inactivate this manager';
            }
        }
    },
    closeSidebar() {
      this.isModalVisible = false;
      this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 1.2rem;
  font-weight: 900;
}
.modal-header {
  padding: 5px;
  border-bottom: 0px;
  margin-bottom: 10px;
  text-align: center !important;
}
.modal-body {
  padding: 5px;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.closeBtn {
  width: 150px;
}
.ma-blue-btn {
  min-height: 35px;
  margin-top: -5px;
  border-radius: 10px;
  width: 150px;
}
.username { font-size: 1.05rem; font-weight: 900; text-align: center; margin: 10px 0; }
.close-icon { position: absolute; left: 0; right: 15px; top: 10px }
.row_lists { width: 100%; }
.data_item { padding: 5px 0; margin-bottom: 5px; font-size: 14px;}
.admin_item_1 { width: 5%; float: left; }
.admin_item_2 { width: 65%; float: left; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.form-label { font-size: 13px; font-weight: 900; } 
.hide_vmessage { display: none !important; }
.show_vmessage { display: block !important; }
.loading_show { height: auto; }
</style>


// WEBPACK FOOTER //
// src/components/manager/update_primary_manager_modal.vue